"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOrphanStyleWrapper = exports.StyledStylesWrapper = exports.StyledTextWrapper = exports.StyledChevronWrapper = exports.StyledIconWrapper = exports.StyledFontIconWrapper = exports.StyledSearchWrapper = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  width: 300px;
  padding: 0 ${({ theme }) => `${ui_common_components_1.utils.rem(6)}`};
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledSearchWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.Medium - theme.Spacing.Size.XSmall)}`};
`;
exports.StyledFontIconWrapper = styled_components_1.default.div `
  display: inline-flex;
  min-width: ${({ theme }) => ui_common_components_1.utils.rem(theme.Icon.Size.Medium)};
  width: ${({ theme }) => ui_common_components_1.utils.rem(theme.Icon.Size.Medium)};
  height: ${({ theme }) => ui_common_components_1.utils.rem(theme.Icon.Size.Medium)};
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.XSmall)};
  background-color: ${({ theme, highlightColor }) => highlightColor ? theme.Color.Neutrals.Border : 'transparent'};
`;
exports.StyledIconWrapper = styled_components_1.default.div `
  display: inline-flex;
  background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  outline: 1px ${({ theme }) => theme.Color.Neutrals.Border} solid;
  outline-offset: -1px;
`;
exports.StyledChevronWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.StyledTextWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  width: 100%;
  max-width: 160px;
  height: 40px;
  justify-content: space-between;
  margin-left: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)}`};
`;
exports.StyledStylesWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledOrphanStyleWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
//# sourceMappingURL=ParagraphStyles.styles.js.map